import React, { Component } from "react";

class PaintingFeatureBox extends Component {
  render() {
    return (
      <div className="heading-bx">
        <h1 className="title mb-0 h3">
          GE DIN BIL NYTT LIV MED PROFESSIONELL <br /> LACKERING!
        </h1>
        <p className="pt-4">
          Hos oss hittar du allt du behöver för att ta hand om din bil. Vi erbjuder professionella bilservice-,
          lackerings- och reparationsarbeten med fokus på kvalitet, noggrannhet och kundnöjdhet. Vår verkstad är
          utrustad med den senaste tekniken för att hantera alla bilmärken och modeller.
        </p>
        <p>
          Vi använder modern utrustning och miljövänliga produkter för att säkerställa en perfekt finish varje gång.
          Våra experter kan matcha alla färger och utföra specialanpassade lackarbeten efter dina önskemål. Oavsett om
          du behöver reparera stenskott eller vill ge din bil ett nytt utseende, är vi här för att hjälpa dig.
        </p>
        <p>
          Låt oss ta hand om din bils yta och ge den en ny, glänsande look. Kontakta oss för att få en kostnadsfri
          konsultation och en offert för din lackering.
        </p>
      </div>
    );
  }
}

export default PaintingFeatureBox;
